import type { AnalyticsProvider } from '@polybank/shared';
import { UmamiAnalyticsProvider } from './umami-provider';

/**
 * Factory — the single swap point for the analytics provider.
 * To switch to PostHog/Mixpanel/etc, only this file needs to change.
 */
export function createAnalyticsProvider(): AnalyticsProvider {
  return new UmamiAnalyticsProvider();
}
